export enum RelatedCardUserActions {
    ADD_MONEY = 'ADD_MONEY',
    EDIT_DATA = 'EDIT_DATA',
    FAVORITE_JOURNEY = 'FAVORITE_JOURNEY',
    REMOVE = 'REMOVE',
    BLOCK = 'BLOCK',
    UNBLOCK = 'UNBLOCK',

}
